// Import necessary libraries, components, and Redux actions
import React, { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv"; // Reusable shared section component
import NeedForMediaAndAdvertising from "../../Pages/AdvertisingAndMediaPlan/NeedForMediaAndAdvertising"; // Component for media/advertising needs
import MarketingResourcesAndPublications from "../../Pages/AdvertisingAndMediaPlan/MarketingResourcesAndPublications"; // Component for marketing resources
import { useDispatch, useSelector } from "react-redux"; // Redux hooks
import { GetAdvertisingPlan } from "../../Redux/Reducers/TextAreaAdvertisingAndMediaPlan"; // Redux action to get advertising plan
import AdvertisingAndMediaPlanForTheProject, {
  GetAdvertisingAndMediaPlanForTheProject,
  UpdateAdvertisingPlan,
  ValidateAdvertisingPlan,
} from "../../Redux/Reducers/AdvertisingAndMediaPlanForTheProject"; // Redux actions for media plan
import ButtonAHSF from "../../Components/ButtonAHSF"; // Reusable button component
import $ from "jquery"; // jQuery for DOM manipulation
import loadConfig from "../../Services/apiService"; // API service
import { useNavigate } from "react-router-dom"; // Navigation hook
import { useParams } from "react-router-dom"; // Hook for getting URL params
import PopupAHSF from "../../Components/PopupAHSF"; // Popup component
import Swal from "sweetalert2"; // SweetAlert2 for notifications

const AdvertisingAndMediaPlan = () => {
  const AppGuid = useParams(); // Get application GUID from URL parameters
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Extract necessary states from Redux store
  const state = useSelector((state) => ({
    AdvertisingAndMediaPlanForTheProject:
      state.AdvertisingAndMediaPlanForTheProject.AdvertisingAndMediaPlanForTheProject,
    AdvertisingAndMediaPlanForTheProjectValidate:
      state.AdvertisingAndMediaPlanForTheProject.AdvertisingAndMediaPlanForTheProjectValidate,
    loadingValidateAdvertisingPlan:
      state.AdvertisingAndMediaPlanForTheProject.loadingValidateAdvertisingPlan,
    ActiveRound: state.ApplicationInformation.ActiveRound,
    ApplicationInformation: state.ApplicationInformation.ApplicationInformation,
  }));

  // State for local data management
  const [dataJsonObject, SetDataJsonObject] = useState(); // Holds JSON config data
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false); // Tracks popup visibility

  // Fetch configuration data
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData); // Update local state with fetched data
  };

  // Save the advertising and media plan
  const SaveDataPage = async (withValidate) => {
    // const saved = await dispatch(
    //   UpdateAdvertisingPlan({ ...state.AdvertisingAndMediaPlanForTheProject })
    // );

    if (withValidate) {
      const validate = await dispatch(
        ValidateAdvertisingPlan(
          state.AdvertisingAndMediaPlanForTheProject.aI_ApplicationInformationId
        )
      );

      // Navigate or trigger popup based on validation result
      if (!validate.payload) {
        $(".BudgetTimeFrame").trigger("click");
      } else {
        setisPopupOpenStatus(true);
      }
    }
  };

  // Determine whether fields should be disabled
  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );





  return (
    <>
      {/* Media and Advertising Needs Section */}
      {/* <NeedForMediaAndAdvertising /> */}

      {/* Marketing Resources and Publications Section */}
      <SharedDiv
        showTitle={true}
        titleName="الموارد التسويقية والمطبوعات" // Arabic for "Marketing Resources and Publications"
        child={[<MarketingResourcesAndPublications />]}
      />

      {/* Buttons for saving and proceeding */}
      {!shouldDisableFields ? (
        <div className="containerButtonMAin">
          {/* Save Button */}
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(false);
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم حفظ المعلومات بنجاح", // Arabic for "Information saved successfully"
                showConfirmButton: false,
                timer: 1000,
              });
            }}
            disabled={false}
            title={"حفظ"} // Arabic for "Save"
            text={"حفظ"} // Arabic for "Save"
            show={true}
          />

          {/* Next Button */}
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(true);
            }}
            disabled={false}
            title={"التالي"} // Arabic for "Next"
            text={"التالي"} // Arabic for "Next"
            show={true}
          />
        </div>
      ) : (
        ""
      )}

      {/* Popup for validation errors */}
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة" // Arabic for "Please fill in the required fields"
        componentBody={state.AdvertisingAndMediaPlanForTheProjectValidate}
      />
    </>
  );
};

export default AdvertisingAndMediaPlan;
